import { render, staticRenderFns } from "./trend-up-fill.vue?vue&type=template&id=79ef4094&"
import script from "./trend-up-fill.vue?vue&type=script&lang=js&"
export * from "./trend-up-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports